module.exports = __webpack_public_path__ + "static/media/1-total.c7ef9104.jpg";